var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      staticClass: "drop-shadow afterSave",
      style: { border: "none" },
      attrs: { "max-width": "600" },
    },
    [
      _c(
        "w-card-title",
        [
          _c("span", [_vm._v(_vm._s(_vm.title))]),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "", disabled: _vm.buttonsDisabled },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-date-picker", {
                    attrs: {
                      "popover-visibility": "focus",
                      label: _vm.$ct("date"),
                      fancy: "",
                      locale: _vm.locale,
                    },
                    model: {
                      value: _vm.bank.TimeCreated,
                      callback: function ($$v) {
                        _vm.$set(_vm.bank, "TimeCreated", $$v)
                      },
                      expression: "bank.TimeCreated",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      label: _vm.$ct("to-pay"),
                      disabled: "",
                      fancy: "",
                    },
                    model: {
                      value: _vm.sale.TotalToPay,
                      callback: function ($$v) {
                        _vm.$set(_vm.sale, "TotalToPay", $$v)
                      },
                      expression: "sale.TotalToPay",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _vm._l(_vm.bankTypeItems, function (b, index) {
                return _c(
                  "w-col",
                  { key: index, staticClass: "payed-row", attrs: { xs: "12" } },
                  [
                    _c("w-input-number", {
                      ref: "bankInput",
                      refInFor: true,
                      style: { marginBottom: "0", flexGrow: 1 },
                      attrs: {
                        label: b.Name,
                        autofocus: b.ID == _vm.selectedBank,
                        disabled: _vm.buttonsDisabled,
                        fancy: "",
                      },
                      model: {
                        value: _vm.payedAmounts[index],
                        callback: function ($$v) {
                          _vm.$set(_vm.payedAmounts, index, $$v)
                        },
                        expression: "payedAmounts[index]",
                      },
                    }),
                    b.ID == _vm.selectedBank
                      ? _c(
                          "w-button",
                          {
                            staticClass: "ml",
                            style: { marginBottom: "0" },
                            attrs: { disabled: _vm.buttonsDisabled },
                            on: {
                              click: function ($event) {
                                return _vm.setTotalPayed(
                                  _vm.amountRounded,
                                  index
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              " € " + _vm._s(_vm.amountRounded.toFixed(2)) + " "
                            ),
                          ]
                        )
                      : _c(
                          "w-button",
                          {
                            staticClass: "ml",
                            attrs: { disabled: _vm.buttonsDisabled },
                            on: {
                              click: function ($event) {
                                return _vm.setTotalPayed(
                                  _vm.amountNotRounded,
                                  index
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              " € " +
                                _vm._s(_vm.amountNotRounded.toFixed(2)) +
                                " "
                            ),
                          ]
                        ),
                  ],
                  1
                )
              }),
              _vm.showPaymentDifferenceCash
                ? _c(
                    "w-col",
                    { staticClass: "difference", attrs: { xs: "12" } },
                    [
                      _c(
                        "w-info",
                        {
                          style: { padding: "10px" },
                          attrs: {
                            ico: "info-circle",
                            "ico-lib": "fas",
                            text: "",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$ct("payment-difference", {
                                  difference: Math.abs(
                                    _vm.paymentDifferenceCash
                                  ).toFixed(2),
                                })
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm.showCtepTerminalSelect
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-row",
                        { attrs: { "no-margin": "" } },
                        [
                          _c("app-ctep-terminal-select", {
                            staticClass: "mr",
                            style: { flexGrow: 1 },
                            attrs: { fancy: "", label: _vm.$ct("terminal") },
                            model: {
                              value: _vm.selectedCtepTerminal,
                              callback: function ($$v) {
                                _vm.selectedCtepTerminal = $$v
                              },
                              expression: "selectedCtepTerminal",
                            },
                          }),
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("use-last-transaction"),
                                  expression: "$ct('use-last-transaction')",
                                },
                              ],
                              style: { flexShrink: 0 },
                              attrs: { flat: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.useCtepLastTransaction()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "history" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.ctepEnabled
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { staticClass: "payed-row", attrs: { xs: "12" } },
                    [
                      _c("w-input-number", {
                        style: { marginBottom: "0", flexGrow: 1 },
                        attrs: {
                          label: _vm.$ct("ctep-terminal"),
                          disabled: _vm.buttonsDisabled,
                          fancy: "",
                        },
                        model: {
                          value: _vm.ctepAmount,
                          callback: function ($$v) {
                            _vm.ctepAmount = $$v
                          },
                          expression: "ctepAmount",
                        },
                      }),
                      _vm.isCtepPaymentBusy
                        ? _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("cancel-ctep-payment"),
                                  expression: "$ct('cancel-ctep-payment')",
                                },
                              ],
                              staticClass: "ml danger",
                              style: { marginBottom: "0" },
                              on: {
                                click: function ($event) {
                                  return _vm.cancelCtepPayment()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "times" } })],
                            1
                          )
                        : _c(
                            "w-button",
                            {
                              staticClass: "ml",
                              attrs: { disabled: _vm.buttonsDisabled },
                              on: {
                                click: function ($event) {
                                  return _vm.setTotalPayedCtep()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " € " +
                                  _vm._s(_vm.amountNotRounded.toFixed(2)) +
                                  " "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showMollieTerminalSelect
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-mollie-terminal-select", {
                        attrs: { fancy: "", label: _vm.$ct("mollie-terminal") },
                        model: {
                          value: _vm.selectedMollieTerminal,
                          callback: function ($$v) {
                            _vm.selectedMollieTerminal = $$v
                          },
                          expression: "selectedMollieTerminal",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.mollieTerminalEnabled
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { staticClass: "payed-row", attrs: { xs: "12" } },
                    [
                      _c("w-input-number", {
                        style: { marginBottom: "0", flexGrow: 1 },
                        attrs: {
                          label: _vm.$ct("mollie-terminal"),
                          disabled: _vm.buttonsDisabled,
                          fancy: "",
                        },
                        model: {
                          value: _vm.mollieAmount,
                          callback: function ($$v) {
                            _vm.mollieAmount = $$v
                          },
                          expression: "mollieAmount",
                        },
                      }),
                      _vm.isMolliePaymentBusy
                        ? _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("cancel-mollie-payment"),
                                  expression: "$ct('cancel-mollie-payment')",
                                },
                              ],
                              staticClass: "ml danger",
                              style: { marginBottom: "0" },
                              on: {
                                click: function ($event) {
                                  return _vm.cancelMolliePayment()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "times" } })],
                            1
                          )
                        : _c(
                            "w-button",
                            {
                              staticClass: "ml",
                              attrs: { disabled: _vm.buttonsDisabled },
                              on: {
                                click: function ($event) {
                                  return _vm.setTotalPayedMollie()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " € " +
                                  _vm._s(_vm.amountNotRounded.toFixed(2)) +
                                  " "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                  _vm.isMolliePaymentBusy && _vm.mollieChangeStateUrl
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c(
                            "w-link",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.openMollieChangeState()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$ct("simulate-mollie-payment")))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _vm.hasModule(_vm.MODULE.CASHDRO)
                ? _c(
                    "w-col",
                    { staticClass: "payed-row", attrs: { xs: "12" } },
                    [
                      _c("w-input-number", {
                        style: { marginBottom: "0", flexGrow: 1 },
                        attrs: {
                          label: _vm.$ct("pay-witch-cashdro"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.cashDroAmount,
                          callback: function ($$v) {
                            _vm.cashDroAmount = $$v
                          },
                          expression: "cashDroAmount",
                        },
                      }),
                      _c(
                        "w-button",
                        {
                          staticClass: "ml",
                          style: { marginBottom: "0" },
                          attrs: { disabled: _vm.buttonsDisabled },
                          on: {
                            click: function ($event) {
                              return _vm.cashdro()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$ct("components.settings-plugin.cashdro")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _vm.cashDroFailed && _vm.cashDroScreenUrl
                        ? _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("CashDro.open-screen"),
                                  expression: "$ct('CashDro.open-screen')",
                                },
                              ],
                              staticClass: "ml danger",
                              style: { marginBottom: "0" },
                              on: {
                                click: function ($event) {
                                  _vm.showCashDroScreen = true
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "desktop" } })],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      label: _vm.$ct("to-refund"),
                      disabled: "",
                      fancy: "",
                    },
                    model: {
                      value: _vm.toRefund,
                      callback: function ($$v) {
                        _vm.toRefund = $$v
                      },
                      expression: "toRefund",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      label: _vm.$ct("left-to-pay"),
                      disabled: "",
                      fancy: "",
                    },
                    model: {
                      value: _vm.sale.TotalOpen,
                      callback: function ($$v) {
                        _vm.$set(_vm.sale, "TotalOpen", $$v)
                      },
                      expression: "sale.TotalOpen",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-textarea-autogrow", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("info"),
                      disabled: _vm.buttonsDisabled,
                    },
                    model: {
                      value: _vm.bank.Info,
                      callback: function ($$v) {
                        _vm.$set(_vm.bank, "Info", $$v)
                      },
                      expression: "bank.Info",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban", disabled: _vm.buttonsDisabled },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _vm.ConnectedDisplay
            ? _c(
                "w-button",
                {
                  staticClass: "mr",
                  attrs: { icon: "desktop" },
                  on: { click: _vm.showOnDisplay },
                },
                [
                  _c("w-fa", {
                    staticClass: "mrs",
                    attrs: { icon: "cash-register" },
                  }),
                  _vm._v(_vm._s(_vm.$ct("show-on-display"))),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-button",
            {
              attrs: {
                disabled: _vm.buttonsDisabled,
                icon: _vm.hasPendingPayments ? "money-bill-wave" : "",
              },
              on: {
                click: function ($event) {
                  return _vm.pay()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("continue")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.showCashDroModal,
            callback: function ($$v) {
              _vm.showCashDroModal = $$v
            },
            expression: "showCashDroModal",
          },
        },
        [
          _c("app-cash-dro-modal", {
            attrs: {
              operation: _vm.cashDroOperation,
              amount: _vm.cashDroAmount,
            },
            on: {
              succes: function ($event) {
                return _vm.onCashDroSucces($event)
              },
              error: function ($event) {
                _vm.showCashDroModal = false
              },
              close: function ($event) {
                _vm.showCashDroModal = false
                _vm.cashDroAmount = 0
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.showCashDroScreen,
            callback: function ($$v) {
              _vm.showCashDroScreen = $$v
            },
            expression: "showCashDroScreen",
          },
        },
        [
          _vm.showCashDroScreen
            ? _c("app-cash-dro-modal", {
                attrs: { "screen-only": "" },
                on: {
                  close: function ($event) {
                    _vm.showCashDroScreen = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.ctepToSendFile
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-send-message-dialog", {
                attrs: {
                  content: "",
                  subject: "Uw bancontact ticket",
                  attachements: [_vm.ctepToSendFile],
                  to: _vm.to,
                },
                on: {
                  sent: function ($event) {
                    return _vm.onCtepSent()
                  },
                  close: function ($event) {
                    return _vm.onCtepSendClose()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }